import { Action } from 'app/store/actions';
import { SearchIndexType } from 'types/search';

export type SearchState = {
  open: boolean;
  filterTypes?: SearchIndexType[];
};

const defaultState = {
  open: false,
};

export default function searchReducer(
  state: SearchState = defaultState,
  action: Action,
): SearchState {
  switch (action.type) {
    case 'SHOW_SEARCH_DIALOG':
      return {
        ...state,
        open: true,
        filterTypes: action.filterTypes,
      };
    case 'HIDE_SEARCH_DIALOG':
      return {
        ...state,
        open: false,
      };
    case 'CHANGE_SEARCH_FILTERS':
      return {
        ...state,
        filterTypes: action.filterTypes,
      };
    default:
      return state;
  }
}
